import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { IMiddleware } from "@/types/middleware/IMiddleware";

export default class MiddlewareBase implements IMiddleware {
	async execute(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<any> {
		throw new Error("method not implemented");
	}
}
